import { trace } from '../../../configuration/setup/trace';
import { sendMessage } from '../widgetServices';
import { widgetActions } from '../widgetSlice';

export const MAP_CHARGING_POINTS_SELECTED_EVENT = 'EVENT_MAP_CHARGING_STATIONS_SELECTED';

export type SelectChargingPointsType = {
    ids: string[];
};
export const selectChargingPointsHandler = (data: SelectChargingPointsType) => {
    trace.debug('Selected charging stations:', data);
};

export const selectChargingPoints = (ids: string[]) => sendMessage(widgetActions.selectChargingPoints({ ids }));
